import React, { memo, useEffect, useRef } from "react";

const ChatDateHeaderComponent: React.FC<{ date?: string }> = ({ date }) => {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    (ref.current?.parentNode as HTMLDivElement)?.classList.add("z-10");
  }, []);
  return (
    <div className="top-4 flex w-full justify-center p-4" ref={ref}>
      <div className="flex h-[22px] items-center justify-center rounded-[11px] bg-gray-200 px-2 py-1 font-secondary text-xs font-medium text-dark-1000">
        {date}
      </div>
    </div>
  );
};

export const ChatDateHeader = memo(ChatDateHeaderComponent);
